<div class="section">
    <div class="chart">
        <div>
            <div class="title">{{ title }}</div>
            <div class="sub-title">{{ title }} collected from system activity</div>
        </div>

        <div *ngIf="isDaily" class="dropdown flex items-center gap-1 -mt-3" style="margin-top: -25px;">
            <label for="monthSelect" class="font-medium text-sm text-gray-700">
                Select Month:
            </label>

            <select id="monthSelect" [(ngModel)]="selectedMonth" (change)="onMonthChange($event)"
                class="form-select px-2 py-1 border rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-orange-400">
                <option *ngFor="let month of getMonthOptions()" [value]="month">
                    {{ month }}
                </option>
            </select>
        </div>

    </div>

    <div class="canvas">
        <canvas [id]="'canvas__' + id" style="margin-top: 10px; width: 100%;"  width="500px" height="263"></canvas>
    </div>
</div>